import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import QuickFacts from "./components/QuickFacts";
import Synopsis from "./components/Synopsis";
import Themes from "./components/Themes";
import Characters from "./components/Characters";
import Cast from "./components/Cast";
import Stills from "./components/Stills";
import Reviews from "./components/Reviews";
import WatchGuide from "./components/WatchGuide";
import Faq from "./components/Faq";
import Related from "./components/Related";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <QuickFacts />
        <Synopsis />
        <Themes />
        <Characters />
        <Cast />
        <Stills />
        <Reviews />
        <WatchGuide />
        <Faq />
        <Related />
      </main>
      <Footer />
    </div>
  );
}